import axios from "axios";
import Helping from '../helpers/Helping';
import { API_URL } from '../config/urls';
import { LOOKUPS } from '../config/routes';
import {
    addNftTypes, addAssets, addDlcTypes, addArtCollections, addArtists, addBrands, addCategories, 
    addEditions, addSeries, addSets, addVariations, addTypes, addIps, addRarities, addLobby, addGenre, addCurrencies, addIllustrator, addWriter
} from './lookup_action';

export const addLookupParents = parents => ({
    type: 'ADD_LOOKUP_PARENTS',
    parents
});

let updateCallback = (res) => {

}


export const setParentLookupError = (callback) => {

    updateCallback = callback;

}

export const fetchLookupParents = (code) => {
    return dispatch => {
        return axios.post(API_URL.ADMIN_TRADING_API + LOOKUPS, {
                "action": "lookup-parent"
            }, Helping.getConfig()).then(response => {
            dispatch(addLookupParents(response.data.payload.lookUp));
        }).catch(error => {
            if (error.response) {
                console.log(error.response);
            }
            return updateCallback({
                ...Helping.setNetworkRequestError(error, "lookups")
            });
        });
    }
};

export const fetchLookupParentsChild = () => {
    return dispatch => {
        return axios.post(API_URL.ADMIN_TRADING_API + LOOKUPS, {
            "action": "all-parent-childs"
        }, Helping.getConfig()).then(response => {
            let lookups = response.data.payload;
            dispatch(addIps(lookups.ip));
            dispatch(addBrands(lookups.brand));
            dispatch(addEditions(lookups.edition));
            dispatch(addCategories(lookups.category));
            dispatch(addTypes(lookups.type));
            dispatch(addSeries(lookups.series));
            dispatch(addSets(lookups.set));
            dispatch(addVariations(lookups.variation));
            dispatch(addRarities(lookups.rarity));
            dispatch(addAssets(lookups.asset));
            dispatch(addArtists(lookups.artist));
            dispatch(addArtCollections(lookups.collection));
            dispatch(addDlcTypes(lookups.dlc_type));
            dispatch(addNftTypes(lookups.nft_type));
            dispatch(addLobby(lookups.lobby));
            dispatch(addGenre(lookups.genre));
            dispatch(addCurrencies(lookups.currencies));
            dispatch(addIllustrator(lookups.illustrator));
            dispatch(addWriter(lookups.writer))
        }).catch(error => {
            if (error.response) {
                console.log(error.response);
            }
            return updateCallback({
                ...Helping.setNetworkRequestError(error, "lookups")
            });
        });
    }
}